import React from 'react';
import PropTypes from 'prop-types';
import without from 'lodash/without';
import ChevronRight from 'common/icons/ChevronRight';
import DropdownMenu from '@radix-ui/react-dropdown-menu';
import Check from 'common/icons/Check';
import { useTouchpointData } from 'common/components/TouchpointEditor/contexts/TouchpointDataContext';
import { useSessions } from 'common/components/TouchpointEditor/contexts/SessionsContext';
import {
    StyledDropdownSubContent,
    StyledDropDownMenuSubTrigger,
    CheckboxSubItem,
    CheckboxIndicator,
    CheckboxFrame,
    TextWithOverflow,
    Filterlabel,
    FilterIndicator,
} from './SessionFilter.styles';

export default function SessionTagsSubFilter({
    backgroundColor,
    backgroundColorHover,
    fontColor,
    fontSize,
    fontFamily,
    iconColor,
    borderColor,
    displayLabel,
}) {
    const {
        theme: { activeFonts, colors },
    } = useTouchpointData();
    const sessions = useSessions();

    const onFilteredTagSelect = (tagName) => {
        const updatedSessionTagFilterIds = sessions.filters.tags.includes(tagName)
            ? without(sessions.filters.tags, tagName)
            : sessions.filters.tags.concat(tagName);
        sessions.filters.setTags(updatedSessionTagFilterIds);
    };

    const sessionTagsSubFilterArray = sessions.uniqueTags || [];
    const tags = sessionTagsSubFilterArray.map((tag) => {
        const checked = sessions.filters.tags.includes(tag);
        return (
            <CheckboxSubItem
                key={tag}
                checked={checked}
                $backgroundColorHover={colors[backgroundColorHover]}
                $borderColor={borderColor}
                onCheckedChange={() => onFilteredTagSelect(tag)}
                onSelect={(e) => e.preventDefault()}
            >
                <CheckboxFrame $iconColor={iconColor}>
                    <CheckboxIndicator>
                        <Check />
                    </CheckboxIndicator>
                </CheckboxFrame>
                <TextWithOverflow>{tag}</TextWithOverflow>
            </CheckboxSubItem>
        );
    });

    return (
        <DropdownMenu.Sub>
            <StyledDropDownMenuSubTrigger
                $fontColor={colors[fontColor]}
                $backgroundColor={colors[backgroundColor]}
                $fontSize={fontSize}
                $fontFamily={activeFonts[fontFamily]}
                $backgroundColorHover={colors[backgroundColorHover]}
                $iconColor={iconColor}
                $borderColor={borderColor}
            >
                <Filterlabel>
                    {displayLabel}
                    {sessions.filters.tags?.length > 0 ? (
                        <FilterIndicator $backgroundColor={colors[fontColor]} $fontColor={colors[backgroundColor]}>
                            {sessions.filters.tags?.length}
                        </FilterIndicator>
                    ) : null}
                </Filterlabel>
                <ChevronRight />
            </StyledDropDownMenuSubTrigger>
            <StyledDropdownSubContent
                $fontColor={colors[fontColor]}
                $backgroundColor={colors[backgroundColor]}
                $fontSize={fontSize}
                $fontFamily={activeFonts[fontFamily]}
            >
                {tags}
            </StyledDropdownSubContent>
        </DropdownMenu.Sub>
    );
}

SessionTagsSubFilter.propTypes = {
    backgroundColor: PropTypes.number.isRequired,
    backgroundColorHover: PropTypes.number.isRequired,
    fontColor: PropTypes.number.isRequired,
    fontSize: PropTypes.number.isRequired,
    fontFamily: PropTypes.number.isRequired,
    displayLabel: PropTypes.string.isRequired,
    iconColor: PropTypes.string.isRequired,
    borderColor: PropTypes.string.isRequired,
};
